<div class="header-bar">
    <div class="header-left"></div>
    <div class="header-center">
      Audience: {{ audience.name }}
    </div>
    <div class="header-right">
      <button
        mat-button
        color="lightGreen"
        (click)="editAudience()"
      >
        Edit Audience
      </button>
    </div>
  </div>
  
  <div class="audience">
    
    <div class="columns">
        <div class="container">
            <div class="container-content">
                <div class="content-title">Status traits</div>
                <div class="content-row">
                    <div>Current audience size:</div>
                    <div>{{audienceCount}}</div>
                </div>
                <div class="content-row">
                    <div>Registration Status:</div>
                    <div>{{uiSvc.stringForFilterRegistrationStatus(audience.registration_state)}}</div>
                </div>
                <div class="content-row">
                    <div>Physical Presence:</div>
                    <div>{{uiSvc.stringForFilterOnOffProp(audience.on_property_state)}}</div>
                </div>
                <div class="content-row">
                    <div>Location Permission:</div>
                    <div>{{uiSvc.stringForFilterNotificationPermission(audience.location_permission_state)}}</div>
                </div>
                <div class="content-row">
                    <div>Notification Permission:</div>
                    <div>{{uiSvc.stringForFilterNotificationPermission(audience.notification_permission_state)}}</div>
                </div>
                <div class="content-row">
                    <div>Bluetooth Permission:</div>
                    <div>{{uiSvc.stringForFilterBluetoothPermission(audience.btle_permission_state)}}</div>
                </div>
                <div class="content-row">
                    <div>Current location(s):</div>
                    <div>{{uiSvc.stringForFilterLocations(audience.locations, geofences.records, beaconRegions.records)}}</div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="container-content">
                <div class="content-title">Behavioral traits</div>
                <div class="content-row" *ngFor="let trait of audience.selected">
                    <div>{{trait.name}}:</div>
                    <div>{{uiSvc.stringForCatalogFilter(trait)}} {{trait.value}}</div>
                </div>
                <div *ngIf="audience.selected.length==0">
                    None
                </div>
            </div>
        </div>
        <div class="container">
            <div class="container-content">
                <div class="content-title">History</div>
                <div class="content-row">
                    <div>Total Broadcasts:</div>
                    <div>{{audience.total_broadcasts}}</div>
                </div>
                <div class="content-row">
                    <div>Last Sent:</div>
                    <div>{{audience.last_broadcast_created_at != null ? formatDate(audience.last_broadcast_created_at) : "-"}}</div>
                </div>
                <div class="content-row">
                    <div>Last Send By:</div>
                    <div>{{audience.last_broadcast_created_at != null ? (audience.last_broadcast_created_by_last_name + ", " + audience.last_broadcast_created_by_first_name) : "-"}}</div>
                </div>
            </div>
        </div>
    </div>

  </div>
  